import { render } from "./AddClasseModal.vue?vue&type=template&id=1cd1fc99&ts=true"
import script from "./AddClasseModal.vue?vue&type=script&lang=ts"
export * from "./AddClasseModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__